import { Component, Input } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-numeric',
  templateUrl: './element-numeric.component.html',
  styleUrl: './element-numeric.component.scss'
})
export class ElementNumericComponent extends ElementBase {
  @Input() showCompletionWarning: boolean = false;
}
